import React, { useMemo } from 'react';
import { useGoodsAwards } from '../queries/useGoodsAwards';
import { isNil } from 'shared/src/utils';
import { TitleContent } from './TitleContent';
import { Colors, Flex, IconArrowRight, Typography } from '@banhala/ui-kit';
import { useGoodsAwardListBottomSheet } from './GoodsAwardListBottomSheet';
import { useOnPressAwardDeeplink } from '../hooks/useOnPressAwardDeeplink';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const GoodsAwardRow: React.FC = () => {
  const { data } = useGoodsAwards();
  const { show: showGoodsAwardListBottomSheet } =
    useGoodsAwardListBottomSheet();

  const onPressAwardDeeplink = useOnPressAwardDeeplink();
  const logEvent = useLogGoodsAnalyticsEvent();

  const targetAward = useMemo(() => {
    if (isNil(data)) return null;
    if (data.awards.length === 0) return null;

    return data.awards[0];
  }, [data]);

  if (isNil(targetAward)) return null;

  return (
    <Flex>
      <TitleContent
        title={'수상정보'}
        onPress={() => {
          logEvent({ name: 'CLICK_BEAUTY_AWARDS' });
          if ((data?.awards ?? []).length > 1) {
            showGoodsAwardListBottomSheet();
            return;
          }
          onPressAwardDeeplink(targetAward.deeplink);
        }}
      >
        <Flex.Row
          alignSelf={'stretch'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Typography type={'body2'} color={'content_primary'}>
            {targetAward.title}
          </Typography>
          <IconArrowRight size={16} color={Colors.content_tertiary} />
        </Flex.Row>
      </TitleContent>
      <TitleContent title={''}>
        <Typography type={'body3'} color={'content_tertiary'}>
          {targetAward.description}
        </Typography>
      </TitleContent>
    </Flex>
  );
};
